module.exports = __webpack_public_path__ + "img/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.dc7637ef.png";